/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Typography, Col, Row, Input, notification, Spin, Space, Tag, Popconfirm, Checkbox } from 'antd';
import React, { useState } from 'react';
import { useGetAnglePresetById, useUpdateFinamePattern } from '../../hooks/useAnglePreset';
import SkeletonImage from '../../commonComponents/ImageSkeleton';
import { useGetPatternOptionsById } from '../../hooks/useCompanies';
import SingleAdaptation from './SingleAdaptation';
const AnglePresetDetails = ({ anglePresetId, unsetAnglePresetId, companyId }) => {
    const [anglePresetDetails, setAnglePresetDetails] = useState({});
    const [disableSave, setDisableSave] = useState(false);
    const [problemPatterns, setProblemPatterns] = useState([]);

    const [api, contextHolder] = notification.useNotification();
    const { data: patternOptionsArr } = useGetPatternOptionsById(companyId);
    const onSuccess = data => {
        setAnglePresetDetails(data);
    };
    const { isFetching } = useGetAnglePresetById(onSuccess, anglePresetId);
    const onUpdateFinamePattern = data => {
        setDisableSave(false);
        if (data.status === 200) {
            unsetAnglePresetId();
        }
    };

    const onUpdateFinamePatternError = error => {
        setDisableSave(false);
        if (error?.response?.status === 400) {
            setProblemPatterns(error?.response?.data?.problemPatterns);
        }
        api['error']({ message: error?.response?.data?.message || 'Something went wrong' });
    }
    const { mutate: UpdateFinamePattern } = useUpdateFinamePattern(onUpdateFinamePattern, onUpdateFinamePatternError);

    const checkSamepatternText = presetsArray => {
        let outPutpatternArray = [...presetsArray]?.map(item => item?.outputFilenamePattern);
        let result = false;

        for (let text of outPutpatternArray) {
            let count = 0;
            for (let anotherText of outPutpatternArray) {
                if (anotherText?.trim() === text?.trim()) {
                    ++count;
                }
            }
            if (count > 1) {
                result = true;
            }
        }
        return result;
    };
    const handleSave = (ignoreCollitions = true) => {
        setDisableSave(true);
        setProblemPatterns([]);
        let tempArray = [];
        anglePresetDetails.angles.map(angle => {
            let test = angle.adaptations.map(adaptaion => {
                return {
                    angleId: angle._id,
                    adaptationId: adaptaion._id,
                    outputFilenamePattern: adaptaion.outputFilenamePattern,
                };
            });
            tempArray = [...tempArray, ...test];
            return test;
        });
        const emptyValue = tempArray.find(item => item.outputFilenamePattern.trim() === '');
        if (emptyValue) {
            api['warning']({ message: 'Filename pattern cannot be empty' });
            setDisableSave(false);
            return;
        }

        UpdateFinamePattern({ updates: tempArray, anglePresetId, ignoreCollitions: ignoreCollitions });
    };

    const checkDuplicatePatterns = () => {
        let tempArray = [];
        anglePresetDetails.angles.forEach(angle => {
            let test = angle.adaptations.map(adaptaion => {
                return {
                    angleId: angle._id,
                    adaptationId: adaptaion._id,
                    outputFilenamePattern: adaptaion.outputFilenamePattern,
                };
            });
            tempArray = [...tempArray, ...test];
        });

        if (!!checkSamepatternText([...tempArray])) {
            return true;
        }
        return false;
    };
    const updateOutputPattern = (value, angleIndex, adaptationIndex) => {
        let tempData = anglePresetDetails;
        tempData.angles[angleIndex].adaptations[adaptationIndex].outputFilenamePattern = value;
        setAnglePresetDetails({ ...tempData });
    };

    return (
        <div>
            {contextHolder}
            <div className="angleDetailsContainer">
                {anglePresetDetails?.angles?.map((angle, angleIndex) => (
                    <Row className="detailsWrapper addBorder" key={angle._id}>
                        <Col span={5} className="addBorder alignContentcenter" style={{ paddingTop: '5px', justifyContent: 'flex-start' }}>
                            <SkeletonImage src={angle?.angle?.file?.thumbPath?.url} height={210} width={140} />
                            <div>
                                <Typography.Title level={5} style={{ margin: 0 }}>
                                    {angle?.angle?.name}
                                    <span style={{ fontSize: '12px', fontWeight: 500 }}>{`   ${angle?.angle?.shootType}`}</span>
                                </Typography.Title>
                            </div>
                        </Col>
                        <Col span={19} className="handleOverFlow">
                            {angle?.adaptations.map((item, adaptaionIndex) => (
                                <SingleAdaptation
                                    key={item._id}
                                    adaptation={item.adaptation}
                                    outputFilenamePattern={item.outputFilenamePattern}
                                    patternOptionsArr={patternOptionsArr}
                                    updateOutputPattern={updateOutputPattern}
                                    angleIndex={angleIndex}
                                    adaptaionIndex={adaptaionIndex}
                                    angleId={angle._id}
                                    adaptationId={item._id}
                                    problemPatterns={problemPatterns}
                                />
                            ))}
                        </Col>
                    </Row>
                ))}
                {isFetching ? (
                    <Row className="alignContentcenter">
                        <Spin tip="Loading..." />
                    </Row>
                ) : !!checkDuplicatePatterns() ? (
                    <Row className="saveButtonRow" style={{ gap: '10px' }}>
                        <Popconfirm
                            title="There are duplicate Output Filename Pattern
                                               in more than one angle."
                            description={`Are you Sure?`}
                            onConfirm={() => handleSave(false)}
                            okText="Yes"
                            cancelText="No"
                            placement="topRight"
                        >
                            <Button type="primary" danger onClick={() => handleSave(true)} disabled={disableSave} loading={disableSave}>
                                Save Without verification
                            </Button>
                            <Button type="primary" disabled={disableSave} loading={disableSave}>
                                Save with verification
                            </Button>
                        </Popconfirm>
                    </Row>
                ) : (
                    <Row className="saveButtonRow" style={{ gap: '10px' }}>
                        <Button type="primary" danger onClick={() => handleSave(true)} disabled={disableSave} loading={disableSave}>
                            Save Without verification
                        </Button>
                        <Button type="primary" onClick={() => handleSave(false)} disabled={disableSave} loading={disableSave}>
                            Save
                        </Button>
                    </Row>
                )}
            </div>
        </div>
    );
};

export default AnglePresetDetails;
